<app-carousel [typeSearch]="'Shop'"></app-carousel>
<div class="body-app mt-3 mb-3">
    <div class="content-app">
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <h5 class="mt-0 mb-2">
                    <i class="fa-solid fa-store"></i>
                    Tienda
                </h5>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            </div>
        </div>
        <div class="row">
            <ng-container *ngFor="let item of products">
                <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12">
                    <a [routerLink]="['/home/shop-detail']" class="text-decoration-none">
                        <div class="card card-shop mb-3">
                            <div class="card-img-top">
                                <img [src]="item.foto" class="img-fluid" alt="foto" />
                            </div>
                            <div class="card-body position-relative">
                                <h6 class="mt-2 mb-0 text-primary">
                                    {{ item.description }}
                                </h6>
                                <p class="mt-0 mb-0 text-left">
                                    {{ item.comment.substring(0, 55) + '...' }}
                                </p>
                                <span class="shop-price">
                                    {{ item.price }}
                                </span>
                                <span class="shop-off" *ngIf="item.off != ''">
                                    {{ item.off }}
                                </span>
                            </div>
                        </div>    
                    </a>
                </div>
            </ng-container>
        </div>
    </div>
</div>